import { defineComponent, ref, computed, watch, resolveComponent, openBlock, createBlock, mergeProps, withCtx, normalizeProps, createTextVNode, toDisplayString, createCommentVNode, renderSlot, inject, nextTick, createElementVNode, guardReactiveProps, createVNode, onMounted, onBeforeUnmount, defineAsyncComponent, resolveDirective, createElementBlock, withDirectives, Fragment, renderList, shallowRef, triggerRef, toValue } from "vue";
import "./i18n-35335a5c.mjs";
import { g as getMimeForFile, f as filesFileTypes, i as imageFileTypes, v as videoFileTypes, b as audiblesFileTypes, c as visualsFileTypes } from "./_common-fcf3ef61.mjs";
import { u as useDefaults, _ as _export_sfc, g as getDefault } from "./_plugin-vue_export-helper-3194dc60.mjs";
import { a as makeVAvatarProps, M as MalarkeyContactAvatar } from "./MalarkeyContactAvatar-1b079ba3.mjs";
import "./MPasswordField.vue_vue_type_script_lang-baf1023a.mjs";
import "./MalarkeyContactRosterItem.vue_vue_type_script_lang-89c5ac30.mjs";
import "./MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "./MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import MalarkeyChatInputForm from "./components/constituants/MalarkeyChatInputForm.es.js";
import "./index-64135f7d.mjs";
import { b as boundUseI18n } from "./_i18n-e414d464.mjs";
import { g as getDisplayNameOfParticipant } from "./malarkeyTwilioAdapter-1c296255.mjs";
import "./event-socket/malarkeyEventSocketAdapter.es.js";
import { d as debug } from "./_debug-8b5c3032.mjs";
import "./otpauth.esm-675c01d0.mjs";
import "./sudo-bad5b55e.mjs";
import { D as DateTime, f as fromMarkdownLike } from "./helpers-674591c1.mjs";
import { u as useTheme } from "./theme-96176369.mjs";
const _sfc_main$5 = defineComponent({
  name: "MalarkeyAttachmentPreview",
  props: {
    ...makeVAvatarProps(),
    file: {
      type: Object,
      default: void 0
    },
    fit: {
      type: String,
      default: "contain"
    },
    iconSize: {
      type: [Number, String],
      default: void 0
    },
    iconColor: {
      type: String,
      default: void 0
    }
  },
  setup(props) {
    const self = ref(null);
    const file = computed(() => props.file);
    const fit = computed(() => props.fit);
    const fileType = computed(
      () => file.value ? getMimeForFile(file.value) : ""
    );
    const kind = computed(() => {
      if (!file.value) {
        return "unknown";
      }
      if (filesFileTypes.includes(fileType.value)) {
        return "file";
      }
      if (imageFileTypes.includes(fileType.value)) {
        return "image";
      }
      if (videoFileTypes.includes(fileType.value)) {
        return "video";
      }
      if (audiblesFileTypes.includes(fileType.value)) {
        return "audible";
      }
      return "unknown";
    });
    const vAvatarDefaults = useDefaults(props, "VAvatar");
    const malarkeyAttachmentPreviewDefaults = useDefaults(
      vAvatarDefaults,
      "MalarkeyAttachmentPreview"
    );
    const icon = computed(() => {
      if (hasError.value) {
        return "mdi-file-alert";
      }
      switch (kind.value) {
        case "file":
          return "mdi-file";
        case "image":
          return null;
        case "video":
          return "mdi-file-video";
        case "audible":
          return "mdi-file-music";
        default:
          return "mdi-file-question";
      }
    });
    const hasError = computed(() => {
      return !file.value || !fileType.value || kind.value === "unknown" || file.value.size > 150 * 1024 * 1024;
    });
    const imageUrl = ref(null);
    const image = computed(() => imageUrl.value);
    const vAvatarBindings = computed(() => ({
      ...malarkeyAttachmentPreviewDefaults,
      file: void 0,
      fit: void 0,
      rounded: "boolean" === typeof props.rounded && props.rounded !== false,
      style: {
        position: "relative"
      },
      color: hasError.value ? "error" : props.color
    }));
    const vImageBindings = computed(() => ({
      src: image.value,
      cover: fit.value === "cover"
    }));
    const vIconBindings = computed(() => ({
      size: props.iconSize,
      color: hasError.value ? void 0 : props.iconColor
    }));
    watch(
      () => file.value,
      (updated) => {
        if (imageUrl.value) {
          URL.revokeObjectURL(imageUrl.value);
        }
        if (updated && imageFileTypes.includes(updated.type)) {
          imageUrl.value = URL.createObjectURL(updated);
        } else {
          imageUrl.value = null;
        }
      },
      { immediate: true }
    );
    return {
      vAvatarBindings,
      kind,
      icon,
      image,
      vImageBindings,
      vIconBindings,
      self,
      fileType
    };
  }
});
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_img = resolveComponent("v-img");
  const _component_v_avatar = resolveComponent("v-avatar");
  return openBlock(), createBlock(_component_v_avatar, mergeProps(_ctx.vAvatarBindings, { ref: "self" }), {
    default: withCtx(() => [
      _ctx.icon ? (openBlock(), createBlock(_component_v_icon, normalizeProps(mergeProps({ key: 0 }, _ctx.vIconBindings)), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.icon), 1)
        ]),
        _: 1
      }, 16)) : createCommentVNode("", true),
      _ctx.image ? (openBlock(), createBlock(_component_v_img, normalizeProps(mergeProps({ key: 1 }, _ctx.vImageBindings)), null, 16)) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "default", { parent: _ctx.self })
    ]),
    _: 3
  }, 16);
}
const MalarkeyAttachmentPreview = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$3], ["__file", "_MalarkeyAttachmentPreview.vue"]]);
var tinyEmitter = { exports: {} };
tinyEmitter.exports;
function E() {
}
E.prototype = {
  on: function(name, callback, ctx) {
    var e = this.e || (this.e = {});
    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx
    });
    return this;
  },
  once: function(name, callback, ctx) {
    var self = this;
    function listener() {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  },
  emit: function(name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;
    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }
    return this;
  },
  off: function(name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];
    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }
    liveEvents.length ? e[name] = liveEvents : delete e[name];
    return this;
  }
};
tinyEmitter.exports = E;
var TinyEmitter = tinyEmitter.exports.TinyEmitter = E;
tinyEmitter.exports;
/**
 * filesize
 *
 * @copyright 2024 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 10.1.2
 */
const ARRAY = "array";
const BIT = "bit";
const BITS = "bits";
const BYTE = "byte";
const BYTES = "bytes";
const EMPTY = "";
const EXPONENT = "exponent";
const FUNCTION = "function";
const IEC = "iec";
const INVALID_NUMBER = "Invalid number";
const INVALID_ROUND = "Invalid rounding method";
const JEDEC = "jedec";
const OBJECT = "object";
const PERIOD = ".";
const ROUND = "round";
const S = "s";
const SI = "si";
const SI_KBIT = "kbit";
const SI_KBYTE = "kB";
const SPACE = " ";
const STRING = "string";
const ZERO = "0";
const STRINGS = {
  symbol: {
    iec: {
      bits: ["bit", "Kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"],
      bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
    },
    jedec: {
      bits: ["bit", "Kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"],
      bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    }
  },
  fullform: {
    iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
    jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"]
  }
};
function filesize(arg, {
  bits = false,
  pad = false,
  base = -1,
  round = 2,
  locale = EMPTY,
  localeOptions = {},
  separator = EMPTY,
  spacer = SPACE,
  symbols = {},
  standard = EMPTY,
  output = STRING,
  fullform = false,
  fullforms = [],
  exponent = -1,
  roundingMethod = ROUND,
  precision = 0
} = {}) {
  let e = exponent, num = Number(arg), result = [], val = 0, u = EMPTY;
  if (standard === SI) {
    base = 10;
    standard = JEDEC;
  } else if (standard === IEC || standard === JEDEC) {
    base = 2;
  } else if (base === 2) {
    standard = IEC;
  } else {
    base = 10;
    standard = JEDEC;
  }
  const ceil = base === 10 ? 1e3 : 1024, full = fullform === true, neg = num < 0, roundingFunc = Math[roundingMethod];
  if (typeof arg !== "bigint" && isNaN(arg)) {
    throw new TypeError(INVALID_NUMBER);
  }
  if (typeof roundingFunc !== FUNCTION) {
    throw new TypeError(INVALID_ROUND);
  }
  if (neg) {
    num = -num;
  }
  if (e === -1 || isNaN(e)) {
    e = Math.floor(Math.log(num) / Math.log(ceil));
    if (e < 0) {
      e = 0;
    }
  }
  if (e > 8) {
    if (precision > 0) {
      precision += 8 - e;
    }
    e = 8;
  }
  if (output === EXPONENT) {
    return e;
  }
  if (num === 0) {
    result[0] = 0;
    u = result[1] = STRINGS.symbol[standard][bits ? BITS : BYTES][e];
  } else {
    val = num / (base === 2 ? Math.pow(2, e * 10) : Math.pow(1e3, e));
    if (bits) {
      val = val * 8;
      if (val >= ceil && e < 8) {
        val = val / ceil;
        e++;
      }
    }
    const p = Math.pow(10, e > 0 ? round : 0);
    result[0] = roundingFunc(val * p) / p;
    if (result[0] === ceil && e < 8 && exponent === -1) {
      result[0] = 1;
      e++;
    }
    u = result[1] = base === 10 && e === 1 ? bits ? SI_KBIT : SI_KBYTE : STRINGS.symbol[standard][bits ? BITS : BYTES][e];
  }
  if (neg) {
    result[0] = -result[0];
  }
  if (precision > 0) {
    result[0] = result[0].toPrecision(precision);
  }
  result[1] = symbols[result[1]] || result[1];
  if (locale === true) {
    result[0] = result[0].toLocaleString();
  } else if (locale.length > 0) {
    result[0] = result[0].toLocaleString(locale, localeOptions);
  } else if (separator.length > 0) {
    result[0] = result[0].toString().replace(PERIOD, separator);
  }
  if (pad && Number.isInteger(result[0]) === false && round > 0) {
    const x = separator || PERIOD, tmp = result[0].toString().split(x), s = tmp[1] || EMPTY, l = s.length, n = round - l;
    result[0] = `${tmp[0]}${x}${s.padEnd(l + n, ZERO)}`;
  }
  if (full) {
    result[1] = fullforms[e] ? fullforms[e] : STRINGS.fullform[standard][e] + (bits ? BIT : BYTE) + (result[0] === 1 ? EMPTY : S);
  }
  return output === ARRAY ? result : output === OBJECT ? {
    value: result[0],
    symbol: result[1],
    exponent: e,
    unit: u
  } : result.join(spacer);
}
const _sfc_main$4 = defineComponent({
  name: "MalarkeyChatMessagePaneItemMedia",
  props: {
    media: {
      type: Object,
      default: void 0
    },
    mine: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    },
    avResult: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["preview:loaded"],
  setup(props, { emit }) {
    const bus = inject("bus");
    const media = computed(() => props.media);
    const contentType = computed(
      () => media.value ? media.value.contentType : "none"
    );
    const fileName = computed(
      () => media.value ? media.value.filename : "none"
    );
    const size = computed(() => media.value ? media.value.size : 0);
    const fileSize = computed(() => filesize(size.value));
    const isImage = computed(() => imageFileTypes.includes(contentType.value));
    const isVideo = computed(() => videoFileTypes.includes(contentType.value));
    const isAudio = computed(
      () => audiblesFileTypes.includes(contentType.value)
    );
    const canPreview = computed(
      () => size.value < 5 * 1024 * 1024 && // (isImage.value || isVideo.value || isAudio.value),
      isImage.value
    );
    const wrapperDivBindings = computed(() => ({
      class: [
        "m-chat-message-item-media",
        "pa-2",
        canPreview.value ? "with-preview" : "without-preview",
        props.last ? "last" : ""
      ]
    }));
    const dropdownButtonBindings = computed(() => ({
      class: ["m-chat-message-item-media-actions-button"],
      icon: true,
      color: "surface",
      size: 18,
      variant: "elevated"
    }));
    const icon = computed(() => {
      if (isImage.value)
        return "mdi-file-image";
      if (isVideo.value)
        return "mdi-file-video";
      if (isAudio.value)
        return "mdi-file-music";
      return "mdi-file";
    });
    const isDownloading = ref(false);
    const onDownloadRequest = async (useSaveAs = false) => {
      if (!media.value)
        return;
      const temporaryUrl = await media.value.getContentTemporaryUrl();
      if (!temporaryUrl) {
        console.error("temporaryUrl is not available");
        return;
      }
      isDownloading.value = true;
      let response;
      try {
        response = await fetch(temporaryUrl);
      } catch (error) {
        debug("fetch error", error);
        isDownloading.value = false;
        return;
      }
      if (!response.ok) {
        debug("response not ok", response);
        isDownloading.value = false;
        return;
      }
      if (useSaveAs) {
        const buffer = await response.arrayBuffer();
        if (typeof window === "undefined" || !window.showSaveFilePicker) {
          debug("showSaveFilePicker is not available");
          isDownloading.value = false;
          return;
        }
        let fileHandle;
        try {
          fileHandle = await window.showSaveFilePicker({
            suggestedName: fileName.value ? fileName.value : void 0
          });
        } catch (error) {
          debug("showSaveFilePicker error", error);
          isDownloading.value = false;
          return;
        }
        let writable;
        try {
          writable = await fileHandle.createWritable();
        } catch (error) {
          debug("createWritable error", error);
          isDownloading.value = false;
          return;
        }
        try {
          await writable.write(buffer);
        } catch (error) {
          debug("write error", error);
          isDownloading.value = false;
          return;
        }
        try {
          await writable.close();
        } catch (error) {
          debug("close error", error);
          isDownloading.value = false;
          return;
        }
      } else if (!fileName.value) {
        isDownloading.value = false;
        return;
      } else if (document) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName.value ? fileName.value : "download";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
      isDownloading.value = false;
    };
    const actionMenuIsOpen = ref(false);
    const preview = ref(null);
    const vImgBindings = computed(() => ({
      class: ["m-chat-message-item-media-image"],
      src: preview.value || void 0,
      maxHeight: 250,
      minWidth: 200
    }));
    const onImageClick = () => {
      if (bus && preview.value) {
        bus.emit(
          "attachments:preview:image",
          {
            local: true
          },
          preview.value
        );
      }
    };
    const loadPreview = async () => {
      if (!media.value) {
        preview.value = null;
        return;
      }
      if (!canPreview.value) {
        preview.value = null;
        return;
      }
      let blob;
      let cacheStorage;
      if (window && window.caches) {
        try {
          cacheStorage = await window.caches.open("m-chat-media");
        } catch {
        }
      }
      if (cacheStorage) {
        let fromCache;
        try {
          fromCache = await cacheStorage.match(media.value.sid);
        } catch {
        }
        if (fromCache && fromCache.ok) {
          try {
            blob = await fromCache.blob();
          } catch {
          }
        }
      }
      if (!blob) {
        const temporaryUrl = await media.value.getContentTemporaryUrl();
        if (!temporaryUrl) {
          console.error("temporaryUrl is not available");
          preview.value = null;
          return;
        }
        let response;
        try {
          response = await fetch(temporaryUrl);
        } catch (error) {
          debug("fetch error", error);
          preview.value = null;
          return;
        }
        if (!response.ok) {
          debug("response not ok", response);
          preview.value = null;
          return;
        }
        blob = await response.blob();
        if (cacheStorage) {
          try {
            await cacheStorage.put(media.value.sid, new Response(blob));
          } catch {
          }
        }
      }
      if (!blob) {
        console.error("blob is not available");
        preview.value = null;
        return;
      }
      const url = URL.createObjectURL(blob);
      preview.value = url;
    };
    const mChatMessageItemMediaCardBindings = computed(() => ({
      class: ["m-chat-message-item-media-card"],
      color: props.mine ? "primary" : "surface"
    }));
    const mChatMessageItemMediaCardListItemBindings = computed(() => ({
      class: ["m-chat-message-item-media-card-list-item"],
      title: fileName.value,
      subtitle: fileSize.value
    }));
    const mChatMessageItemMediaCardListItemAvatarBindings = computed(() => ({
      color: props.mine ? "secondary" : "primary"
    }));
    const onPreviewLoaded = () => {
      debug("preview loaded within media");
      emit("preview:loaded");
    };
    watch(
      () => media.value,
      () => {
        if (preview.value) {
          URL.revokeObjectURL(preview.value);
        }
        loadPreview();
      },
      { immediate: true }
    );
    watch(
      () => preview.value,
      (is) => {
        if (is) {
          nextTick(() => {
            onPreviewLoaded();
          });
        }
      }
    );
    return {
      contentType,
      size,
      wrapperDivBindings,
      dropdownButtonBindings,
      actionMenuIsOpen,
      canPreview,
      vImgBindings,
      onDownloadRequest,
      isDownloading,
      onImageClick,
      mChatMessageItemMediaCardBindings,
      mChatMessageItemMediaCardListItemBindings,
      icon,
      mChatMessageItemMediaCardListItemAvatarBindings
    };
  }
});
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_img = resolveComponent("v-img");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_avatar = resolveComponent("v-avatar");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_hover = resolveComponent("v-hover");
  return openBlock(), createBlock(_component_v_hover, null, {
    default: withCtx(({ isHovering, props }) => [
      createElementVNode("div", normalizeProps(guardReactiveProps({ ..._ctx.wrapperDivBindings, ...props })), [
        _ctx.canPreview ? (openBlock(), createBlock(_component_v_img, mergeProps({ key: 0 }, _ctx.vImgBindings, { onClick: _ctx.onImageClick }), null, 16, ["onClick"])) : (openBlock(), createBlock(_component_v_card, mergeProps({ key: 1 }, _ctx.mChatMessageItemMediaCardBindings, {
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.onDownloadRequest())
        }), {
          default: withCtx(() => [
            createVNode(_component_v_list_item, normalizeProps(guardReactiveProps(_ctx.mChatMessageItemMediaCardListItemBindings)), {
              prepend: withCtx(() => [
                createVNode(_component_v_avatar, normalizeProps(guardReactiveProps(_ctx.mChatMessageItemMediaCardListItemAvatarBindings)), {
                  default: withCtx(() => [
                    createVNode(_component_v_icon, null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.icon), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 16)),
        isHovering || _ctx.actionMenuIsOpen ? (openBlock(), createBlock(_component_v_menu, {
          key: 2,
          modelValue: _ctx.actionMenuIsOpen,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.actionMenuIsOpen = $event)
        }, {
          activator: withCtx(({ props: props2 }) => [
            createVNode(_component_v_btn, normalizeProps(guardReactiveProps({ ..._ctx.dropdownButtonBindings, ...props2 })), {
              default: withCtx(() => [
                createVNode(_component_v_icon, { size: "14" }, {
                  default: withCtx(() => [
                    createTextVNode("mdi-dots-vertical")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1040)
          ]),
          default: withCtx(() => [
            createVNode(_component_v_card, null, {
              default: withCtx(() => [
                createVNode(_component_v_list_item, {
                  icon: "mdi-download",
                  title: _ctx.$t("malarkeyChat.actions.download"),
                  disabled: _ctx.isDownloading,
                  onClick: _cache[1] || (_cache[1] = ($event) => _ctx.onDownloadRequest())
                }, null, 8, ["title", "disabled"]),
                createVNode(_component_v_list_item, {
                  icon: "mdi-download-box",
                  title: _ctx.$t("malarkeyChat.actions.saveAs"),
                  disabled: _ctx.isDownloading,
                  onClick: _cache[2] || (_cache[2] = ($event) => _ctx.onDownloadRequest(true))
                }, null, 8, ["title", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["modelValue"])) : createCommentVNode("", true),
        false === _ctx.avResult ? (openBlock(), createBlock(_component_v_avatar, {
          key: 3,
          color: "green",
          size: "15",
          style: { "float": "left", "position": "relative", "top": "-5px" }
        }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              class: "m-chat-message-item-media-av-result",
              size: "11"
            }, {
              default: withCtx(() => [
                createTextVNode(" mdi-shield-check ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ], 16)
    ]),
    _: 1
  });
}
const MalarkeyChatMessagePaneItemMedia = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$2], ["__file", "_MalarkeyChatMessagePaneItemMedia.vue"]]);
const _sfc_main$3 = defineComponent({
  name: "MalarkeyChatMessageReactionListItem",
  components: {
    MalarkeyContactAvatar
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    /**
     * An array of participants in the conversation.
     */
    participants: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const bus = inject("bus");
    const message = computed(() => props.message);
    const participants = computed(() => props.participants);
    const participant = computed(
      () => participants.value.find((p) => p.sid === message.value.participantSid)
    );
    const messageContactAvatarBindings = computed(() => {
      if (!participant.value || !participant.value.identity) {
        return {
          size: 30
        };
      }
      return {
        identity: participant.value.identity,
        size: 30
      };
    });
    const title = ref(
      participant.value ? getDisplayNameOfParticipant(participant.value) : ""
    );
    const onTwilioUpdatedParticipant = ({
      participant: updatedParticipant
    }) => {
      var _a;
      if (updatedParticipant.sid === ((_a = participant.value) == null ? void 0 : _a.sid)) {
        title.value = getDisplayNameOfParticipant(updatedParticipant);
      }
    };
    const onTwilioRosterUpdated = () => {
      if (participant.value) {
        title.value = getDisplayNameOfParticipant(participant.value);
      }
    };
    const messageIndicatedTime = computed(() => {
      if (!message.value || !message.value.dateCreated) {
        return "";
      }
      const dto = DateTime.fromJSDate(message.value.dateCreated);
      return dto.toLocaleString(DateTime.TIME_SIMPLE);
    });
    const reaction = computed(
      () => {
        var _a;
        return ((_a = message.value.attributes) == null ? void 0 : _a.reaction) || "❔";
      }
    );
    onMounted(() => {
      if (bus) {
        bus.on("twilio:client:participantUpdated", onTwilioUpdatedParticipant, {
          local: true
        });
        bus.on("twilio:adapter:roster:updated", onTwilioRosterUpdated, {
          local: true
        });
      }
    });
    onBeforeUnmount(() => {
      if (bus) {
        bus.off(
          "twilio:client:participantUpdated",
          onTwilioUpdatedParticipant,
          {
            local: true
          }
        );
        bus.off("twilio:adapter:roster:updated", onTwilioRosterUpdated, {
          local: true
        });
      }
    });
    return {
      messageContactAvatarBindings,
      title,
      messageIndicatedTime,
      reaction
    };
  }
});
const _hoisted_1$1 = { style: { "font-size": "24px" } };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MalarkeyContactAvatar = resolveComponent("MalarkeyContactAvatar");
  const _component_v_avatar = resolveComponent("v-avatar");
  const _component_v_list_item = resolveComponent("v-list-item");
  return openBlock(), createBlock(_component_v_list_item, {
    title: _ctx.title,
    subtitle: _ctx.messageIndicatedTime
  }, {
    prepend: withCtx(() => [
      createVNode(_component_MalarkeyContactAvatar, normalizeProps(guardReactiveProps(_ctx.messageContactAvatarBindings)), null, 16)
    ]),
    append: withCtx(() => [
      createVNode(_component_v_avatar, {
        size: "30",
        color: "transparent"
      }, {
        default: withCtx(() => [
          createElementVNode("span", _hoisted_1$1, toDisplayString(_ctx.reaction), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "subtitle"]);
}
const MalarkeyChatMessageReactionListItem = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$1], ["__file", "_MalarkeyChatMessageReactionListItem.vue"]]);
const EmojiPicker = defineAsyncComponent(() => import("./emoji-picker.es-e6a1836f.mjs"));
const _sfc_main$2 = defineComponent({
  name: "MalarkeyChatMessagePaneItem",
  components: {
    MalarkeyContactAvatar,
    MalarkeyChatMessagePaneItemMedia,
    EmojiPicker,
    MalarkeyChatMessageReactionListItem
  },
  props: {
    /**
     * The message to display in the chat message pane.
     */
    message: {
      type: Object,
      default: void 0
    },
    /**
     * An array of participants in the conversation.
     */
    participants: {
      type: Array,
      default: () => []
    },
    /**
     * Determines if the message is the last message send by the same sender.
     */
    isLastMessageBySameSender: {
      type: Boolean,
      default: false
    },
    /**
     * The archived state of the conversation.
     */
    archived: {
      type: Boolean,
      default: false
    },
    /**
     * The messages which are reactions to the current message
     */
    reactions: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    /**
     * Emitted when the message card is intersected by the viewport.
     */
    "seen",
    /**
     * Emitted when a preview of a media message card is loaded
     */
    "preview:loaded",
    /**
     * Emitted when the user has selected to reply to this message.
     */
    "reply",
    /**
     * Emitted when the user has selected to react to this message.
     */
    "react",
    /**
     * Emitted when the user has selected to edit this message.
     */
    "edit",
    /**
     * Emitted when the user has selected to delete this message.
     */
    "delete"
  ],
  setup(props, { emit }) {
    const { t } = boundUseI18n();
    const { current } = useTheme();
    const bus = inject("bus");
    const identity = inject("identity");
    const alert = inject("alert");
    const archived = computed(() => props.archived);
    const message = computed(() => props.message);
    const participants = computed(() => props.participants);
    const reactions = computed(() => props.reactions);
    const hasReactions = computed(() => reactions.value.length > 0);
    const isLastMessageBySameSender = computed(
      () => props.isLastMessageBySameSender
    );
    const myParticipanSid = computed(() => {
      if (!identity) {
        return void 0;
      }
      if (!identity.user.value) {
        return void 0;
      }
      const participant = participants.value.find(
        (p) => p.identity === identity.user.value.id
      );
      if (!participant) {
        return void 0;
      }
      return participant.sid;
    });
    const isGroupChat = computed(() => participants.value.length > 2);
    const isMyMessage = computed(
      () => message.value && myParticipanSid.value === message.value.participantSid
    );
    const isReplyTo = computed(
      () => message.value && "attributes" in message.value && "object" === typeof message.value.attributes && null !== message.value.attributes && "isReplyTo" in message.value.attributes && message.value.attributes.isReplyTo !== null ? message.value.attributes.isReplyTo : void 0
    );
    const isReplyToContent = computed(
      () => message.value && "attributes" in message.value && "object" === typeof message.value.attributes && null !== message.value.attributes && "isReplyToContent" in message.value.attributes && message.value.attributes.isReplyToContent !== null ? message.value.attributes.isReplyToContent : void 0
    );
    const antivirusResults = computed(
      () => message.value && "attributes" in message.value && "object" === typeof message.value.attributes && null !== message.value.attributes && "bytescale" in message.value.attributes && message.value.attributes.bytescale !== null ? message.value.attributes.bytescale : {}
    );
    const isReply = computed(
      () => isReplyTo.value !== void 0 && isReplyToContent.value !== void 0
    );
    const isReplyToContentFormatted = computed(
      () => isReplyToContent.value ? fromMarkdownLike(isReplyToContent.value) : void 0
    );
    const dateCreated = computed(
      () => message.value && message.value.dateCreated ? DateTime.fromJSDate(message.value.dateCreated) : void 0
    );
    const dateUpdated = computed(
      () => message.value && message.value.dateUpdated ? DateTime.fromJSDate(message.value.dateUpdated) : void 0
    );
    const wasEdited = computed(
      () => dateUpdated.value && dateCreated.value && dateUpdated.value > dateCreated.value
    );
    const itemDiv = ref(
      null
    );
    const itemDivBindings = computed(() => ({
      class: [
        "m-chat-message-item",
        isMyMessage.value ? "m-chat-message-item--mine" : "m-chat-message-item--theirs",
        !isLastMessageBySameSender.value ? "m-chat-message-item--tail" : void 0,
        hasReactions.value ? "mb-8" : "mb-3"
      ].filter((v) => "string" === typeof v),
      for: message.value ? message.value.sid : void 0,
      id: message.value ? [message.value.conversation.sid, message.value.index].join("-") : void 0
    }));
    const shouldShowMessageAvatar = computed(
      () => isGroupChat.value && !isMyMessage.value && isLastMessageBySameSender.value
    );
    const shouldShowMessageAvatarInsert = computed(
      () => isGroupChat.value && !isMyMessage.value && !isLastMessageBySameSender.value
    );
    const messageContactAvatarBindings = computed(() => {
      if (!message.value) {
        return void 0;
      }
      const participant = participants.value.find(
        (p) => p.sid === message.value.participantSid
      );
      if (!participant || !participant.identity) {
        return {
          class: ["me-2"]
        };
      }
      return {
        identity: participant.identity,
        class: ["me-2"]
      };
    });
    const vCardDefaults = useDefaults({}, "VCard");
    const messageCardDefaults = useDefaults(
      vCardDefaults,
      "MalarkeyChatMessageCard"
    );
    const myMessageCardDefaults = useDefaults(
      {
        ...messageCardDefaults,
        color: getDefault("color", "MalarkeyChatMessageCardMine", "primary")
      },
      "MalarkeyChatMessageCardMine"
    );
    const theirMessageCardDefaults = useDefaults(
      {
        ...messageCardDefaults,
        color: getDefault(
          "color",
          "MalarkeyChatMessageCardTheirs",
          "secondary"
        )
      },
      "MalarkeyChatMessageCardTheirs"
    );
    const baseMessageCardDefaults = computed(
      () => isMyMessage.value ? myMessageCardDefaults : theirMessageCardDefaults
    );
    const conversation = computed(
      () => message.value ? message.value.conversation : void 0
    );
    const isActive = computed(() => conversation.value !== void 0);
    const isArchived = computed(
      () => conversation.value === void 0 || typeof conversation.value.state === "undefined" || conversation.value.state.current !== "active"
    );
    const messageCard = ref(null);
    const messageCardMenuAnchor = ref(
      null
    );
    const showContextMenu = ref(false);
    const messageCardBindings = computed(() => ({
      ...baseMessageCardDefaults.value,
      class: ["m-chat-message-item-card", "w-100"],
      style: {
        opacity: showContextMenu.value ? 0.83 : 1
      },
      elevation: showContextMenu.value ? 4 : null
    }));
    const messageCardTextContentArea = ref(
      null
    );
    const messageCardTextContentAreaShowMore = ref(false);
    const messageCardTextContentAreaBindings = computed(() => ({
      class: messageCardTextContentAreaShowMore.value ? ["m-chat-message-item-text-body", "pt-1", "pb-6", "px-2"] : ["m-chat-message-item-text-body", "pa-0", "mt-1", "mb-6", "mx-2"],
      style: {
        maxHeight: messageCardTextContentAreaShowMore.value ? void 0 : "200px"
      }
    }));
    const messageCardTextContentAreaInteriorHeight = ref(0);
    const updateMessageCardTextContentAreaInteriorHeight = () => {
      if (messageCardTextContentArea.value) {
        let totalContentHeight = 0;
        const children = messageCardTextContentArea.value.$el.children;
        for (let i = 0; i < children.length; i++) {
          totalContentHeight += children[i].clientHeight;
        }
        messageCardTextContentAreaInteriorHeight.value = totalContentHeight;
      }
    };
    const emitSeenIfVisible = () => {
      if (itemDiv.value) {
        const rect = itemDiv.value.getBoundingClientRect();
        let parent = itemDiv.value.parentElement;
        while (parent && !parent.classList.contains("m-chat-message-pane")) {
          parent = parent.parentElement;
        }
        if (!parent) {
          return;
        }
        const parentRect = parent.getBoundingClientRect();
        if (rect.top > parentRect.bottom && rect.bottom > parentRect.bottom || rect.bottom < parentRect.top && rect.top < parentRect.top) {
          return;
        }
        if (message.value) {
          emit("seen", message.value.index);
        }
        if (Array.isArray(reactions.value)) {
          reactions.value.forEach((r) => {
            emit("seen", r.index);
          });
        }
      }
    };
    const onMessageCardIntersection = (isIntersecting) => {
      if (isIntersecting && message.value) {
        emitSeenIfVisible();
      }
    };
    const contextMenuX = ref(0);
    const contextMenuY = ref(0);
    const contextMenuAnchorBinding = computed(() => ({
      style: {
        top: `${contextMenuY.value}px`,
        left: `${contextMenuX.value}px`
      }
    }));
    const onMessageCardContextMenu = (e) => {
      e.preventDefault();
      if (isArchived.value || archived.value) {
        return false;
      }
      if (showContextMenu.value === true) {
        showContextMenu.value = false;
      }
      nextTick(() => {
        if (!messageCard.value || !messageCardMenuAnchor.value) {
          return;
        }
        const rect = messageCard.value.$el.getBoundingClientRect();
        contextMenuX.value = e.clientX - rect.left;
        contextMenuY.value = e.clientY - rect.top;
        showContextMenu.value = true;
      });
      return false;
    };
    const onMessageCardContextMenuLongTouchRequest = (e) => {
      if (isArchived.value || archived.value) {
        return false;
      }
      if (showContextMenu.value === true) {
        showContextMenu.value = false;
      }
      nextTick(() => {
        if (!messageCard.value || !messageCardMenuAnchor.value) {
          return;
        }
        const rect = messageCard.value.$el.getBoundingClientRect();
        let hasTouchWithinRect = false;
        [...e.touches].forEach((tp) => {
          if (tp.clientX >= rect.left && tp.clientX <= rect.right && tp.clientY >= rect.top && tp.clientY <= rect.bottom) {
            hasTouchWithinRect = true;
          }
        });
        [...e.changedTouches].forEach((tp) => {
          if (tp.clientX >= rect.left && tp.clientX <= rect.right && tp.clientY >= rect.top && tp.clientY <= rect.bottom) {
            hasTouchWithinRect = true;
          }
        });
        if (!hasTouchWithinRect) {
          return;
        }
        contextMenuX.value = 0;
        contextMenuY.value = 0;
        showContextMenu.value = true;
      });
      return false;
    };
    const contextMenuBindings = computed(() => ({
      activator: messageCardMenuAnchor.value,
      closeOnBack: false,
      closeOnContentClick: true,
      noClickAnimation: true,
      openOnClick: false,
      openOnFocus: false
    }));
    const textBody = computed(
      () => message.value && message.value.body ? fromMarkdownLike(message.value.body) : void 0
    );
    const textSource = computed(
      () => message.value && message.value.body ? message.value.body : void 0
    );
    const showReadMore = computed(
      () => textBody.value && messageCardTextContentAreaInteriorHeight.value > 200 && !messageCardTextContentAreaShowMore.value
    );
    const onReadMoreClick = (e) => {
      e.preventDefault();
      messageCardTextContentAreaShowMore.value = true;
    };
    const messageIndicatedTime = computed(() => {
      if (!message.value || !message.value.dateCreated) {
        return "";
      }
      const dto = DateTime.fromJSDate(message.value.dateCreated);
      return dto.toLocaleString(DateTime.TIME_SIMPLE);
    });
    const onMessageLinkClick = (e) => {
      e.preventDefault();
      const href = e.target.href;
      if (href && bus) {
        bus.emit(
          "link:clicked",
          {
            local: true
          },
          href
        );
      }
    };
    const bindMessageLinkClicks = () => {
      var _a;
      if (messageCardTextContentArea.value) {
        const links = messageCardTextContentArea.value.$el.querySelectorAll("a");
        for (let i = 0; i < links.length; i++) {
          const clone = links[i].cloneNode(true);
          clone.addEventListener("click", onMessageLinkClick);
          (_a = links[i].parentNode) == null ? void 0 : _a.replaceChild(clone, links[i]);
        }
      }
    };
    const onConversationMountedComplete = (c) => {
      if (!c) {
        return;
      }
      if (!message.value) {
        return;
      }
      if (c.sid !== message.value.conversation.sid) {
        return;
      }
      emitSeenIfVisible();
    };
    watch(
      () => textBody.value,
      () => {
        bindMessageLinkClicks();
      },
      { immediate: true }
    );
    const media = computed(() => {
      if (!message.value || !message.value.attachedMedia) {
        return [];
      }
      return message.value.attachedMedia;
    });
    const onMediaPreviewLoaded = () => {
      emit("preview:loaded");
    };
    const showMessageActions = ref(false);
    const reactionsMenuOpenedBy = ref(void 0);
    const reactionsMenuAnchor = computed(() => {
      switch (reactionsMenuOpenedBy.value) {
        case "action-pre":
        case "action-post":
        case "context":
          return messageCard.value;
        default:
          return itemDiv.value;
      }
    });
    const showReactionsMenu = computed({
      get() {
        return "string" === typeof reactionsMenuOpenedBy.value && reactionsMenuAnchor.value !== void 0 && reactionsMenuAnchor.value !== null;
      },
      set(val) {
        switch (val) {
          case "action-pre":
          case "action-post":
          case "context":
            reactionsMenuOpenedBy.value = val;
            break;
          default:
            reactionsMenuOpenedBy.value = void 0;
            break;
        }
      }
    });
    const reactionsMenuBindings = computed(() => ({
      activator: reactionsMenuAnchor.value,
      location: "top",
      persistent: false,
      closeOnContentClick: false,
      width: 258,
      minWidth: 258,
      maxWidth: 258,
      class: ["m-chat-message-item-reactions-menu"]
    }));
    const messageActionsPre = ref(
      null
    );
    const messageActionsPost = ref(
      null
    );
    const messageActionsBindings = computed(() => ({
      style: {
        opacity: showMessageActions.value || showReactionsMenu.value ? 1 : 0
      },
      class: ["m-chat-message-item-actions"]
    }));
    const onMouseMoveOver = (e) => {
      const rectangles = [];
      if (messageCard.value) {
        rectangles.push(messageCard.value.$el.getBoundingClientRect());
      }
      if (messageActionsPre.value) {
        rectangles.push(messageActionsPre.value.getBoundingClientRect());
      }
      if (messageActionsPost.value) {
        rectangles.push(messageActionsPost.value.getBoundingClientRect());
      }
      const x = e.clientX;
      const y = e.clientY;
      const inDesiredRectangle = rectangles.some((r) => {
        return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
      });
      if (inDesiredRectangle) {
        showMessageActions.value = true;
      } else {
        showMessageActions.value = false;
      }
    };
    const onTabInactive = () => {
      showMessageActions.value = false;
    };
    const openReactionsMenuFrom = (from) => {
      showReactionsMenu.value = from;
    };
    const canReply = computed(
      () => textSource.value !== void 0 && !archived.value
    );
    const onDoReply = () => {
      if (!message.value || !canReply.value) {
        return;
      }
      emit("reply", message.value.sid);
      if (bus) {
        bus.emit(
          "conversation:message:reply",
          {
            local: true
          },
          message.value
        );
      }
    };
    const onDoReact = () => {
      if (!message.value) {
        return;
      }
      openReactionsMenuFrom("context");
    };
    const sendReactions = (emoji) => {
      if (!message.value) {
        return;
      }
      emit("react", message.value.sid, emoji);
      if (bus) {
        bus.emit(
          "conversation:message:react",
          {
            local: true
          },
          message.value,
          emoji
        );
      }
      message.value.conversation.prepareMessage().setAttributes({
        reaction: emoji,
        reactionTo: message.value.sid
      }).setBody(`Reacted with ${emoji}`).build().send();
      reactionsMenuOpenedBy.value = void 0;
    };
    const onDoCopy = () => {
      if (!message.value || !textSource.value) {
        debug("no message or text source");
        return;
      }
      if (window && "navigator" in window && "clipboard" in window.navigator) {
        window.navigator.clipboard.writeText(textSource.value).then(() => {
          debug("copied");
        }).catch((e) => {
          debug(e);
        });
      } else {
        debug("no clipboard");
      }
    };
    const onDoDelete = () => {
      if (!message.value || !isMyMessage.value) {
        return;
      }
      message.value.remove().then(() => {
        debug("Deleted Message");
      }).catch((e) => {
        debug(e);
        if (e.message === "Forbidden" && alert) {
          alert(
            "errors.chat.delete.forbidden.title",
            "errors.chat.delete.forbidden.text"
          );
        }
      });
    };
    const onDoEdit = () => {
      if (!message.value || !isMyMessage.value) {
        return;
      }
      emit("edit", message.value.sid);
      if (bus) {
        bus.emit(
          "conversation:message:edit",
          {
            local: true
          },
          message.value
        );
      }
    };
    const emojiMenuOpen = ref(false);
    const selectEmoji = (emoji) => {
      emojiMenuOpen.value = false;
      reactionsMenuOpenedBy.value = void 0;
      if (!message.value) {
        return;
      }
      emit("react", message.value.sid, emoji.i);
    };
    const emojiGroupNames = computed(() => ({
      smileys_people: t("malarkeyChat.emojis.smileys_people"),
      animals_nature: t("malarkeyChat.emojis.animals_nature"),
      food_drink: t("malarkeyChat.emojis.food_drink"),
      activities: t("malarkeyChat.emojis.activities"),
      travel_places: t("malarkeyChat.emojis.travel_places"),
      objects: t("malarkeyChat.emojis.objects"),
      symbols: t("malarkeyChat.emojis.symbols"),
      flags: t("malarkeyChat.emojis.flags")
    }));
    const emojiStaticTexts = computed(() => ({
      placeholder: t("malarkeyChat.emojis.placeholder"),
      skinTone: t("malarkeyChat.emojis.skinTone")
    }));
    const emojiPickerTheme = computed(
      () => current.value.dark ? "dark" : "light"
    );
    const emojiButtonDisabled = computed(() => !isActive.value);
    const reactionMenuEmojiButton = ref(null);
    const reactionEmojiMenuActivator = computed(
      () => reactionMenuEmojiButton.value ? reactionMenuEmojiButton.value.$el : void 0
    );
    const reactionCountsByEmoji = computed(() => {
      const counts = {};
      reactions.value.forEach((r) => {
        if (r.attributes && r.attributes.reaction) {
          const reaction = r.attributes.reaction;
          if (counts[reaction]) {
            counts[reaction]++;
          } else {
            counts[reaction] = 1;
          }
        }
      });
      return counts;
    });
    onMounted(() => {
      updateMessageCardTextContentAreaInteriorHeight();
      bindMessageLinkClicks();
      if (bus) {
        bus.on("conversation:mounted:complete", onConversationMountedComplete, {
          local: true
        });
        bus.on("tab:active", emitSeenIfVisible, {
          local: true
        });
        bus.on("tab:inactive", onTabInactive, {
          local: true
        });
        bus.on("longtouch", onMessageCardContextMenuLongTouchRequest, {
          local: true
        });
      }
    });
    return {
      itemDiv,
      itemDivBindings,
      shouldShowMessageAvatar,
      shouldShowMessageAvatarInsert,
      messageContactAvatarBindings,
      messageCard,
      messageCardBindings,
      messageCardTextContentArea,
      messageCardTextContentAreaBindings,
      onMessageCardIntersection,
      onMessageCardContextMenu,
      showContextMenu,
      contextMenuBindings,
      contextMenuAnchorBinding,
      messageCardMenuAnchor,
      textBody,
      messageIndicatedTime,
      showReadMore,
      onReadMoreClick,
      media,
      isMyMessage,
      onMediaPreviewLoaded,
      isActive,
      isArchived,
      canReply,
      onDoReply,
      onDoReact,
      onDoCopy,
      onDoDelete,
      onDoEdit,
      messageActionsPre,
      messageActionsPost,
      onMouseMoveOver,
      messageActionsBindings,
      openReactionsMenuFrom,
      reactionsMenuBindings,
      showReactionsMenu,
      sendReactions,
      emojiMenuOpen,
      selectEmoji,
      emojiButtonDisabled,
      emojiGroupNames,
      emojiStaticTexts,
      emojiPickerTheme,
      reactionMenuEmojiButton,
      reactionEmojiMenuActivator,
      hasReactions,
      reactionCountsByEmoji,
      isReplyTo,
      isReplyToContentFormatted,
      isReply,
      wasEdited,
      antivirusResults
    };
  }
});
const _hoisted_1 = {
  key: 1,
  class: "msg-avatar-spacer me-2"
};
const _hoisted_2 = {
  class: "d-inline-flex flex-column justify-start align-start",
  style: { "min-width": "80px", "max-width": "80%", "position": "relative" }
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "d-flex justify-end m-chat-message-item-indicators px-2" };
const _hoisted_5 = ["textContent"];
const _hoisted_6 = {
  key: 1,
  class: "me-2"
};
const _hoisted_7 = ["textContent"];
const _hoisted_8 = {
  key: 0,
  style: { "height": "0", "position": "relative", "overflow": "visible" }
};
const _hoisted_9 = {
  key: 0,
  class: "m-chat-message-item-reactions-chip-reaction-count"
};
const _hoisted_10 = { class: "d-flex w-100 h-100 align-center justify-center m-chat-message-item-reaction-options" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MalarkeyContactAvatar = resolveComponent("MalarkeyContactAvatar");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_v_alert = resolveComponent("v-alert");
  const _component_MalarkeyChatMessagePaneItemMedia = resolveComponent("MalarkeyChatMessagePaneItemMedia");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_MalarkeyChatMessageReactionListItem = resolveComponent("MalarkeyChatMessageReactionListItem");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_btn = resolveComponent("v-btn");
  const _directive_intersect = resolveDirective("intersect");
  return openBlock(), createElementBlock("div", mergeProps({ ref: "itemDiv" }, _ctx.itemDivBindings, {
    onMousemove: _cache[11] || (_cache[11] = (...args) => _ctx.onMouseMoveOver && _ctx.onMouseMoveOver(...args)),
    onMouseenter: _cache[12] || (_cache[12] = (...args) => _ctx.onMouseMoveOver && _ctx.onMouseMoveOver(...args)),
    onMouseleave: _cache[13] || (_cache[13] = (...args) => _ctx.onMouseMoveOver && _ctx.onMouseMoveOver(...args))
  }), [
    _ctx.shouldShowMessageAvatar ? (openBlock(), createBlock(_component_MalarkeyContactAvatar, normalizeProps(mergeProps({ key: 0 }, _ctx.messageContactAvatarBindings)), null, 16)) : createCommentVNode("", true),
    _ctx.shouldShowMessageAvatarInsert ? (openBlock(), createElementBlock("div", _hoisted_1)) : createCommentVNode("", true),
    _ctx.isMyMessage && !_ctx.archived ? (openBlock(), createElementBlock("div", mergeProps({
      key: 2,
      ref: "messageActionsPre"
    }, _ctx.messageActionsBindings), [
      createVNode(_component_v_fab, {
        icon: "",
        size: "40",
        variant: "tonal",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.openReactionsMenuFrom("action-pre"))
      }, {
        default: withCtx(() => [
          createVNode(_component_v_icon, null, {
            default: withCtx(() => [
              createTextVNode("mdi-emoticon-excited-outline")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 16)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_2, [
      withDirectives((openBlock(), createBlock(_component_v_card, mergeProps({ ref: "messageCard" }, _ctx.messageCardBindings, { onContextmenuCapture: _ctx.onMessageCardContextMenu }), {
        default: withCtx(() => [
          createElementVNode("div", mergeProps({
            class: "m-card-menu-anchor",
            ref: "messageCardMenuAnchor"
          }, _ctx.contextMenuAnchorBinding), null, 16),
          _ctx.isReply ? (openBlock(), createBlock(_component_v_alert, {
            key: 0,
            border: "start",
            density: "compact",
            variant: "tonal",
            class: "m-chat-message-item-replying-to mb-2"
          }, {
            default: withCtx(() => [
              createElementVNode("span", { innerHTML: _ctx.isReplyToContentFormatted }, null, 8, _hoisted_3)
            ]),
            _: 1
          })) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.media, (m, i) => {
            return openBlock(), createBlock(_component_MalarkeyChatMessagePaneItemMedia, {
              key: `media-${m.sid}`,
              media: m,
              mine: _ctx.isMyMessage,
              last: i === _ctx.media.length - 1,
              avResult: _ctx.antivirusResults[m.sid],
              "onPreview:loaded": _ctx.onMediaPreviewLoaded
            }, null, 8, ["media", "mine", "last", "avResult", "onPreview:loaded"]);
          }), 128)),
          _ctx.textBody ? (openBlock(), createBlock(_component_v_card_text, mergeProps({
            key: 1,
            ref: "messageCardTextContentArea"
          }, _ctx.messageCardTextContentAreaBindings, { innerHTML: _ctx.textBody }), null, 16, ["innerHTML"])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_4, [
            _ctx.showReadMore ? (openBlock(), createElementBlock("a", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onReadMoreClick && _ctx.onReadMoreClick(...args)),
              class: "m-chat-message-item-read-more",
              textContent: toDisplayString(_ctx.$t("malarkeyChat.actions.readMore"))
            }, null, 8, _hoisted_5)) : createCommentVNode("", true),
            _ctx.wasEdited ? (openBlock(), createElementBlock("span", _hoisted_6, toDisplayString(_ctx.$t("malarkeyChat.info.edited")), 1)) : createCommentVNode("", true),
            _ctx.messageIndicatedTime ? (openBlock(), createElementBlock("span", {
              key: 2,
              textContent: toDisplayString(_ctx.messageIndicatedTime)
            }, null, 8, _hoisted_7)) : createCommentVNode("", true)
          ]),
          createVNode(_component_v_menu, mergeProps({
            modelValue: _ctx.showContextMenu,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.showContextMenu = $event)
          }, _ctx.contextMenuBindings), {
            default: withCtx(() => [
              createVNode(_component_v_card, null, {
                default: withCtx(() => [
                  _ctx.canReply ? (openBlock(), createBlock(_component_v_list_item, {
                    key: 0,
                    title: _ctx.$t("malarkeyChat.actions.reply"),
                    onClick: _ctx.onDoReply
                  }, null, 8, ["title", "onClick"])) : createCommentVNode("", true),
                  !_ctx.isArchived ? (openBlock(), createBlock(_component_v_list_item, {
                    key: 1,
                    title: _ctx.$t("malarkeyChat.actions.react"),
                    onClick: _ctx.onDoReact
                  }, null, 8, ["title", "onClick"])) : createCommentVNode("", true),
                  createVNode(_component_v_list_item, {
                    title: _ctx.$t("malarkeyChat.actions.copy"),
                    onClick: _ctx.onDoCopy
                  }, null, 8, ["title", "onClick"]),
                  _ctx.isMyMessage && !_ctx.archived ? (openBlock(), createBlock(_component_v_list_item, {
                    key: 2,
                    title: _ctx.$t("malarkeyChat.actions.delete"),
                    onClick: _ctx.onDoDelete
                  }, null, 8, ["title", "onClick"])) : createCommentVNode("", true),
                  _ctx.isMyMessage && !_ctx.archived ? (openBlock(), createBlock(_component_v_list_item, {
                    key: 3,
                    title: _ctx.$t("malarkeyChat.actions.edit"),
                    onClick: _ctx.onDoEdit
                  }, null, 8, ["title", "onClick"])) : createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 16, ["modelValue"])
        ]),
        _: 1
      }, 16, ["onContextmenuCapture"])), [
        [_directive_intersect, { handler: _ctx.onMessageCardIntersection }]
      ]),
      _ctx.hasReactions ? (openBlock(), createElementBlock("div", _hoisted_8, [
        createVNode(_component_v_tooltip, {
          location: "top",
          "content-class": "m-chat-message-item-reactions-chip-tooltip"
        }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_chip, mergeProps({
              class: "m-chat-message-item-reactions-chip",
              density: "compact",
              variant: "elevated",
              color: "surface"
            }, props), {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.reactionCountsByEmoji, (count, emoji) => {
                  return openBlock(), createElementBlock("span", {
                    key: emoji,
                    class: "mx-1"
                  }, [
                    createTextVNode(toDisplayString(emoji) + " ", 1),
                    count > 1 ? (openBlock(), createElementBlock("span", _hoisted_9, toDisplayString(count), 1)) : createCommentVNode("", true)
                  ]);
                }), 128))
              ]),
              _: 2
            }, 1040)
          ]),
          default: withCtx(() => [
            createVNode(_component_v_card, {
              color: "transparent",
              flat: "",
              width: "250"
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.reactions, (r, i) => {
                  return openBlock(), createElementBlock(Fragment, {
                    key: `reaction-${r.sid}`
                  }, [
                    createVNode(_component_MalarkeyChatMessageReactionListItem, {
                      message: r,
                      participants: _ctx.participants
                    }, null, 8, ["message", "participants"]),
                    i < _ctx.reactions.length - 1 ? (openBlock(), createBlock(_component_v_divider, { key: 0 })) : createCommentVNode("", true)
                  ], 64);
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])) : createCommentVNode("", true)
    ]),
    !_ctx.isMyMessage && !_ctx.archived ? (openBlock(), createElementBlock("div", mergeProps({
      key: 3,
      ref: "messageActionsPost"
    }, _ctx.messageActionsBindings), [
      createVNode(_component_v_fab, {
        icon: "",
        size: "40",
        variant: "tonal",
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.openReactionsMenuFrom("action-post"))
      }, {
        default: withCtx(() => [
          createVNode(_component_v_icon, null, {
            default: withCtx(() => [
              createTextVNode("mdi-emoticon-excited-outline")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 16)) : createCommentVNode("", true),
    createVNode(_component_v_menu, mergeProps(_ctx.reactionsMenuBindings, {
      modelValue: _ctx.showReactionsMenu,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => _ctx.showReactionsMenu = $event)
    }), {
      default: withCtx(() => [
        createVNode(_component_v_card, {
          variant: "outlined",
          density: "compact",
          rounded: "pill",
          height: "40"
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_10, [
              createVNode(_component_v_btn, {
                color: _ctx.messageCardBindings.color,
                "base-color": "surface",
                icon: true,
                size: "34",
                class: "mx-1",
                variant: "tonal",
                onClick: _cache[4] || (_cache[4] = ($event) => _ctx.sendReactions("👍"))
              }, {
                default: withCtx(() => [
                  createTextVNode(" 👍 ")
                ]),
                _: 1
              }, 8, ["color"]),
              createVNode(_component_v_btn, {
                color: _ctx.messageCardBindings.color,
                "base-color": "surface",
                icon: true,
                size: "34",
                class: "mx-1",
                variant: "tonal",
                onClick: _cache[5] || (_cache[5] = ($event) => _ctx.sendReactions("❤️"))
              }, {
                default: withCtx(() => [
                  createTextVNode(" ❤️ ")
                ]),
                _: 1
              }, 8, ["color"]),
              createVNode(_component_v_btn, {
                color: _ctx.messageCardBindings.color,
                "base-color": "surface",
                icon: true,
                size: "34",
                class: "mx-1",
                variant: "tonal",
                onClick: _cache[6] || (_cache[6] = ($event) => _ctx.sendReactions("😂"))
              }, {
                default: withCtx(() => [
                  createTextVNode(" 😂 ")
                ]),
                _: 1
              }, 8, ["color"]),
              createVNode(_component_v_btn, {
                color: _ctx.messageCardBindings.color,
                "base-color": "surface",
                icon: true,
                size: "34",
                class: "mx-1",
                variant: "tonal",
                onClick: _cache[7] || (_cache[7] = ($event) => _ctx.sendReactions("😮"))
              }, {
                default: withCtx(() => [
                  createTextVNode(" 😮 ")
                ]),
                _: 1
              }, 8, ["color"]),
              createVNode(_component_v_btn, {
                color: _ctx.messageCardBindings.color,
                "base-color": "surface",
                icon: true,
                size: "34",
                class: "mx-1",
                variant: "tonal",
                onClick: _cache[8] || (_cache[8] = ($event) => _ctx.sendReactions("😢"))
              }, {
                default: withCtx(() => [
                  createTextVNode(" 😢 ")
                ]),
                _: 1
              }, 8, ["color"]),
              createVNode(_component_v_btn, {
                color: _ctx.messageCardBindings.color,
                "base-color": "surface",
                icon: true,
                size: "34",
                class: "mx-1",
                variant: "tonal",
                onClick: _cache[9] || (_cache[9] = ($event) => _ctx.sendReactions("🙏"))
              }, {
                default: withCtx(() => [
                  createTextVNode(" 🙏 ")
                ]),
                _: 1
              }, 8, ["color"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["modelValue"])
  ], 16);
}
const MalarkeyChatMessagePaneItem = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render], ["__file", "MalarkeyChatMessagePaneItem.vue"]]);
const _sfc_main$1 = defineComponent({
  name: "MalarkeyChatMessagePane",
  components: {
    MalarkeyContactAvatar,
    MalarkeyChatMessagePaneItem
  },
  props: {
    /**
     * The conversation object that the chat input form is associated with.
     */
    conversation: {
      type: Object,
      default: void 0
    },
    /**
     * An array of participants in the conversation.
     */
    participants: {
      type: Array,
      default: () => []
    },
    /**
     * The archived state of the conversation.
     */
    archived: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const bus = inject("bus");
    const identity = inject("identity");
    const internalBus = new TinyEmitter();
    const conversation = computed(() => props.conversation);
    const participants = computed(() => props.participants);
    const messages = shallowRef([]);
    const mediaPreviewLoadedFirst = ref(false);
    const wrapper = ref(null);
    const wrapperBindings = computed(() => ({
      class: ["m-chat-message-pane", "w-100", "d-flex", "align-start"],
      style: {
        overflowY: "auto",
        overflowX: "hidden",
        maxHeight: "100%"
      }
    }));
    const scrollable = ref(null);
    const scrollableBindings = computed(() => ({
      class: [
        "m-chat-message-pane__scrollable",
        "w-100",
        "d-flex",
        "flex-column",
        "align-start",
        "justify-end",
        "py-3",
        "px-4"
      ],
      style: {
        overflowX: "visible",
        position: "relative"
      }
    }));
    const mutatedSinceLoadingOlderMessages = ref(false);
    const onScrollableMutated = () => {
      debug("scrollable mutated", scrollable.value);
      internalBus.emit("mutated");
      mutatedSinceLoadingOlderMessages.value = true;
    };
    const topBar = ref(null);
    const topBarBindings = computed(() => ({
      class: ["m-chat-message-pane__top-bar"],
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "40px"
      }
    }));
    const isLoadingEarlier = ref(false);
    const isLoadingInitial = ref(true);
    const isLoading = computed(
      () => isLoadingEarlier.value || isLoadingInitial.value
    );
    const loaderBar = ref(null);
    const loaderBarBindings = computed(() => ({
      class: ["m-chat-message-pane__loader-bar"],
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0
      }
    }));
    const loadMessagesAbortController = ref(
      void 0
    );
    const myParticipanSid = computed(() => {
      if (!identity) {
        return void 0;
      }
      if (!identity.user.value) {
        return void 0;
      }
      const participant = participants.value.find(
        (p) => p.identity === identity.user.value.id
      );
      if (!participant) {
        return void 0;
      }
      return participant.sid;
    });
    const sortedMessages = computed(
      () => [...messages.value].sort((a, b) => a.index - b.index).filter(() => "string" === typeof myParticipanSid.value).filter(
        (m) => !(typeof m.attributes === "object" && null !== m.attributes && "string" === typeof m.attributes.reactionTo)
      )
    );
    const messageReactions = computed(
      () => [...messages.value].sort((a, b) => a.index - b.index).filter(() => "string" === typeof myParticipanSid.value).filter(
        (m) => typeof m.attributes === "object" && null !== m.attributes && "string" === typeof m.attributes.reactionTo
      )
    );
    const messageBytescaleReports = computed(
      () => [...messages.value].sort((a, b) => a.index - b.index).filter(() => "string" === typeof myParticipanSid.value).filter(
        (m) => typeof m.attributes === "object" && null !== m.attributes && "undefined" !== typeof m.attributes.bytescale
      )
    );
    const messageReactionsByMessageSid = computed(() => {
      const ret = {};
      messageReactions.value.forEach((m) => {
        if (typeof m.attributes === "object" && null !== m.attributes) {
          const reactionTo = m.attributes.reactionTo;
          if (typeof reactionTo === "string") {
            if (!ret[reactionTo]) {
              ret[reactionTo] = [];
            }
            ret[reactionTo].push(m);
          }
        }
      });
      return ret;
    });
    const messageBytescaleReportsByMessageSid = computed(() => {
      const ret = {};
      messageBytescaleReports.value.forEach((m) => {
        if (typeof m.attributes === "object" && null !== m.attributes) {
          const bytescale = m.attributes.bytescale;
          if (typeof bytescale === "object") {
            if (!ret[m.sid]) {
              ret[m.sid] = [];
            }
            ret[m.sid].push(m);
          }
        }
      });
      return ret;
    });
    const oldestIndex = computed(
      () => (
        // @ts-ignore
        [...sortedMessages.value].map((m) => m.index).sort((a, b) => a - b)[0]
      )
    );
    const getIsLastMessageBySameSender = (msg, index) => {
      const nextMessage = sortedMessages.value[index + 1];
      return nextMessage && nextMessage.participantSid === msg.participantSid;
    };
    let lastHighestIndex = 0;
    const onMessageSeen = (index) => {
      if (conversation.value) {
        if (index > lastHighestIndex) {
          lastHighestIndex = index;
          conversation.value.advanceLastReadMessageIndex(index).then(() => {
            debug(`Advanced last read message index to ${index}`);
            if (bus) {
              bus.emit("conversation:read:index:advanced", {
                local: true
              });
            }
          }).catch((e) => {
            debug("Error advancing last read message index", e);
          });
        }
      }
    };
    const scrollToLatest = () => {
      if (wrapper.value) {
        debug(
          "Scrolling to latest",
          wrapper.value.scrollTop,
          wrapper.value.scrollHeight
        );
        wrapper.value.scrollTop = wrapper.value.scrollHeight;
      } else {
        debug("Nothing is scrollable");
      }
    };
    const loadOlderMessagesAbortController = ref(
      void 0
    );
    const elementByIndex = (index) => {
      if (!conversation.value || !wrapper.value) {
        return void 0;
      }
      const id = [conversation.value.sid, index].join("-");
      console.log(id);
      return document.getElementById(id);
    };
    const loadOlderMessages = async () => {
      if (conversation.value && oldestIndex.value > 0 && !isLoadingEarlier.value) {
        isLoadingEarlier.value = true;
        if (loadOlderMessagesAbortController.value) {
          loadOlderMessagesAbortController.value.abort();
        }
        loadOlderMessagesAbortController.value = new AbortController();
        const currentOldestIndex = oldestIndex.value;
        try {
          const paginator = await conversation.value.getMessages(
            21,
            oldestIndex.value
          );
          const { items } = paginator;
          items.forEach((msg) => {
            const exists = messages.value.find((m) => m.sid === msg.sid);
            if (!exists) {
              messages.value.push(msg);
            }
          });
          triggerRef(messages);
          if (!mutatedSinceLoadingOlderMessages.value) {
            await new Promise((resolve) => {
              internalBus.once("mutated", resolve);
            });
          }
          mutatedSinceLoadingOlderMessages.value = false;
          nextTick(() => {
            const elem = elementByIndex(currentOldestIndex);
            if (elem && wrapper.value) {
              const scrollPosition = elem.offsetTop;
              debug("Scrolling to", scrollPosition);
              wrapper.value.scrollTop = scrollPosition;
            }
          });
        } catch (error) {
          debug("Error loading older messages", error);
        }
        isLoadingEarlier.value = false;
      }
    };
    const onMessageListTopIntersect = (isIntersecting) => {
      if (isIntersecting) {
        debug("onMessageListTopIntersect", isIntersecting);
        loadOlderMessages();
      }
    };
    watch(
      () => conversation.value,
      (is) => {
        mediaPreviewLoadedFirst.value = false;
        if (loadMessagesAbortController.value) {
          loadMessagesAbortController.value.abort();
        }
        if (is) {
          isLoadingInitial.value = true;
          loadMessagesAbortController.value = new AbortController();
          is.getMessages().then((msgs) => {
            if (loadMessagesAbortController.value && !loadMessagesAbortController.value.signal.aborted) {
              messages.value = msgs.items;
              triggerRef(messages);
              debug(`Loaded ${msgs.items.length} messages`);
              isLoadingInitial.value = false;
              requestAnimationFrame(scrollToLatest);
            }
          }).catch((e) => {
            debug("Error loading messages", e);
            messages.value = [];
            triggerRef(messages);
          });
        } else {
          isLoadingInitial.value = false;
          isLoadingEarlier.value = false;
          messages.value = [];
          triggerRef(messages);
          debug("No conversation, clearing messages");
        }
      },
      { immediate: true }
    );
    const onMessageAdded = (msg) => {
      if (conversation.value && msg.conversation && msg.conversation.sid === conversation.value.sid) {
        messages.value.push(msg);
        triggerRef(messages);
        requestAnimationFrame(scrollToLatest);
      }
    };
    const onMessageRemoved = (msg) => {
      if (conversation.value && msg.conversation && msg.conversation.sid === conversation.value.sid) {
        const index = messages.value.findIndex((m) => m.sid === msg.sid);
        if (index > -1) {
          messages.value.splice(index, 1);
          triggerRef(messages);
        }
      }
    };
    const onMessageUpdated = ({
      message: msg
    }) => {
      if (conversation.value && msg.conversation && msg.conversation.sid === conversation.value.sid) {
        const index = messages.value.findIndex((m) => m.sid === msg.sid);
        debug("Message updated", msg, index);
        if (index > -1) {
          messages.value.splice(index, 1, msg);
          triggerRef(messages);
          debug("Message replaced", msg, index);
        }
      }
    };
    let mediaPreviewLoadedTimeout;
    const onMediaPreviewLoaded = () => {
      if (mediaPreviewLoadedTimeout) {
        clearTimeout(mediaPreviewLoadedTimeout);
      }
      mediaPreviewLoadedTimeout = setTimeout(() => {
        debug("Media preview loaded from message pane");
        if (!mediaPreviewLoadedFirst.value) {
          mediaPreviewLoadedFirst.value = true;
          scrollToLatest();
        }
        if (bus) {
          bus.emit(
            "conversation:mounted:complete",
            { local: true },
            conversation.value
          );
        }
      }, 100);
    };
    onMounted(() => {
      if (bus) {
        bus.on("twilio:client:messageAdded", onMessageAdded, { local: true });
        bus.on("twilio:client:messageRemoved", onMessageRemoved, {
          local: true
        });
        bus.on("twilio:client:messageUpdated", onMessageUpdated, {
          local: true
        });
        setTimeout(() => {
          bus.emit(
            "conversation:mounted:complete",
            { local: true },
            conversation.value
          );
        }, 250);
      }
    });
    onBeforeUnmount(() => {
      if (bus) {
        bus.off("twilio:client:messageAdded", onMessageAdded, { local: true });
        bus.off("twilio:client:messageRemoved", onMessageRemoved, {
          local: true
        });
        bus.off("twilio:client:messageUpdated", onMessageUpdated, {
          local: true
        });
      }
    });
    return {
      scrollToLatest,
      wrapper,
      wrapperBindings,
      scrollable,
      scrollableBindings,
      onScrollableMutated,
      topBar,
      topBarBindings,
      onMessageListTopIntersect,
      isLoading,
      loaderBar,
      loaderBarBindings,
      sortedMessages,
      getIsLastMessageBySameSender,
      onMessageSeen,
      onMediaPreviewLoaded,
      messageReactionsByMessageSid,
      messageBytescaleReportsByMessageSid
    };
  }
});
const _sfc_main = defineComponent({
  name: "MalarkeyAttachmentPane",
  components: {
    MalarkeyAttachmentPreview,
    MalarkeyChatInputForm
  },
  props: {
    /**
     * The conversation to which the files belong.
     */
    conversation: {
      type: Object,
      default: void 0
    },
    /**
     * The files to display in the attachment pane.
     */
    files: {
      type: Array,
      default: void 0
    }
  },
  emits: {
    /**
     * Event emitted when the attachment pane is closed.
     */
    close: () => void 0
  },
  setup(props, { emit }) {
    const { t } = boundUseI18n();
    const alert = inject("alert");
    const sounds = inject("sounds");
    const isSubmitting = ref(false);
    const conversation = computed(() => props.conversation);
    const filesFromProps = computed(() => props.files);
    const files = shallowRef(props.files);
    const captions = /* @__PURE__ */ new Map();
    const hasFiles = computed(
      () => files.value && files.value.some((f) => filesFileTypes.includes(f.type))
    );
    const hasVisuals = computed(
      () => files.value && files.value.some((f) => visualsFileTypes.includes(f.type))
    );
    const hasAudibles = computed(
      () => files.value && files.value.some((f) => audiblesFileTypes.includes(f.type))
    );
    const title = computed(() => {
      switch (true) {
        case (hasFiles.value && hasVisuals.value && hasAudibles.value):
        case (hasFiles.value && hasVisuals.value):
        case (hasFiles.value && hasAudibles.value):
          return t("malarkeyAttachmentPane.title.all");
        case hasFiles.value:
          return t("malarkeyAttachmentPane.title.files");
        case (hasVisuals.value && hasAudibles.value):
          return t("malarkeyAttachmentPane.title.media");
        case hasVisuals.value:
          return t("malarkeyAttachmentPane.title.visuals");
        case hasAudibles.value:
          return t("malarkeyAttachmentPane.title.audibles");
        default:
          return t("malarkeyAttachmentPane.title.all");
      }
    });
    const cardBindings = computed(() => ({
      class: ["m-attachment-pane", "d-flex", "flex-column"]
    }));
    const responsiveContainer = ref(null);
    const responsiveContainerWidth = ref(0);
    const updateResponsiveContainerWidth = () => {
      if (!responsiveContainer.value) {
        return;
      }
      responsiveContainerWidth.value = responsiveContainer.value.$el.clientWidth;
    };
    const iconSize = computed(() => responsiveContainerWidth.value * 0.6);
    const currentIndex = ref(0);
    watch(
      () => conversation.value,
      (current) => {
        if (!current) {
          emit("close");
        }
      },
      { immediate: true }
    );
    watch(
      () => filesFromProps.value,
      (current) => {
        if (!current) {
          emit("close");
        }
        files.value = current;
        triggerRef(files);
      },
      { immediate: true }
    );
    watch(
      () => files.value,
      (current) => {
        if (!current) {
          captions.clear();
          return;
        }
        captions.forEach((_, key) => {
          if (!current.includes(key)) {
            captions.delete(key);
          }
        });
        if (current.length < currentIndex.value) {
          currentIndex.value = 0;
        }
      }
    );
    watch(
      () => currentIndex.value,
      (current) => {
        if (!files.value) {
          emit("close");
          return;
        }
        if (!current) {
          currentIndex.value = 0;
          return;
        }
        if (current < 0) {
          currentIndex.value = 0;
          return;
        }
        if (current >= files.value.length) {
          currentIndex.value = files.value.length - 1;
          return;
        }
      },
      { immediate: true }
    );
    onMounted(() => {
      currentIndex.value = 0;
      updateResponsiveContainerWidth();
    });
    const vTabBindings = computed(() => ({
      alignTabs: "center",
      hideSlider: true,
      mandatory: true,
      height: 50
    }));
    const vTabsBindings = computed(
      () => !files.value ? [] : [...files.value].map((f, i) => ({
        props: {
          file: f,
          size: 50,
          fit: "cover",
          class: currentIndex.value !== i ? ["m-attachment-pane-tab-preview"] : [
            "m-attachment-pane-tab-preview",
            "m-attachment-pane-tab-preview--active"
          ],
          rounded: true,
          color: "primary"
        },
        tab: {
          width: 60,
          maxWith: 60,
          minWidth: 60,
          value: i,
          ripple: false
        },
        key: ["file", f.name, f.size, f.type, f.lastModified, i].join("-")
      }))
    );
    const onOverlayClick = (index) => {
      if (!files.value) {
        return;
      }
      const nextCurrentIndex = currentIndex.value === index ? index - 1 > 0 ? index - 1 : 0 : index;
      files.value.splice(index, 1);
      if (files.value.length === 0) {
        emit("close");
        return;
      }
      currentIndex.value = nextCurrentIndex;
      triggerRef(files);
      currentIndex.value = nextCurrentIndex;
    };
    const currentFile = computed(() => {
      if (!files.value) {
        return void 0;
      }
      return files.value[currentIndex.value];
    });
    const currentFileName = computed(() => {
      if (!currentFile.value) {
        return void 0;
      }
      return currentFile.value.name;
    });
    const currentFileSize = computed(() => {
      if (!currentFile.value) {
        return void 0;
      }
      return filesize(currentFile.value.size);
    });
    const currentCaption = computed({
      get() {
        if (!currentFile.value) {
          return "";
        }
        return captions.get(currentFile.value) || "";
      },
      set(value) {
        if (!currentFile.value) {
          return;
        }
        captions.set(currentFile.value, value);
      }
    });
    const doOnSubmit = async () => {
      if (!conversation.value || !files.value) {
        return;
      }
      isSubmitting.value = true;
      const fls = toValue(files);
      const hasFilesWhichAreTooLarge = fls.some(
        (f) => f.size > 150 * 1024 * 1024
      );
      if (hasFilesWhichAreTooLarge) {
        if (alert) {
          await alert(
            "errors.attach.tooLargeFiles.title",
            "errors.attach.tooLargeFiles.text"
          );
        }
        isSubmitting.value = false;
        return;
      }
      const filesWhichAreUnsupported = fls.some((f) => !getMimeForFile(f));
      if (filesWhichAreUnsupported) {
        if (alert) {
          await alert(
            "errors.attach.unsupportedFiles.title",
            "errors.attach.unsupportedFiles.text"
          );
        }
        isSubmitting.value = false;
        return;
      }
      const messageBuilders = [];
      let currentMessageBuilder;
      let currentMessageBuilderSize = 0;
      for (const f of fls) {
        const caption = captions.get(f);
        const mediaOptions = {
          contentType: getMimeForFile(f),
          filename: f.name,
          media: f
        };
        if (caption) {
          const mb = conversation.value.prepareMessage().setBody(caption).addMedia(mediaOptions);
          messageBuilders.push(mb);
        } else {
          if (!currentMessageBuilder) {
            currentMessageBuilder = conversation.value.prepareMessage();
          }
          if (currentMessageBuilderSize + f.size > 150 * 1024 * 1024) {
            messageBuilders.push(currentMessageBuilder);
            currentMessageBuilder = conversation.value.prepareMessage();
            currentMessageBuilderSize = 0;
          }
          currentMessageBuilder.addMedia(mediaOptions);
          currentMessageBuilderSize += f.size;
        }
      }
      if (currentMessageBuilder) {
        messageBuilders.push(currentMessageBuilder);
      }
      await Promise.all(
        messageBuilders.map(async (mb) => {
          try {
            await mb.build().send();
          } catch (error) {
            debug("Error sending message", error);
          }
        })
      );
      if (sounds) {
        try {
          sounds.play("onMessageSent");
        } catch {
        }
      }
      isSubmitting.value = false;
      emit("close");
    };
    return {
      cardBindings,
      title,
      responsiveContainer,
      updateResponsiveContainerWidth,
      responsiveContainerWidth,
      iconSize,
      currentIndex,
      vTabBindings,
      vTabsBindings,
      onOverlayClick,
      currentFile,
      currentFileName,
      currentFileSize,
      doOnSubmit,
      currentCaption,
      isSubmitting
    };
  }
});
export {
  MalarkeyChatMessagePaneItem as M,
  _sfc_main as _,
  _sfc_main$1 as a
};
//# sourceMappingURL=MalarkeyAttachmentPane.vue_vue_type_script_lang-d0f606dc.mjs.map
